import { gql } from '@apollo/client';

export const GET_TOP_BRAND_NAMES = gql`
  query GetTopBrandNames($filters: DistributionGraphsInput) {
    getTopBrandNames(input: $filters) {
      amountOfListings
      label
    }
  }
`;
